module.exports = __webpack_public_path__ + "img/bell.bd51f0aa.png";